
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'itemsContainer': {'height': `100%`,'width': `80%`,'margin': `16px 0px`,},'itemContainer': {'display': `flex`,'margin': `16px 0px`,},'itemImage': {'width': `60px`,'height': `auto`,'marginRight': `8px`,'borderRadius': `0%`,},'textContainer': {'display': `flex`,'flexDirection': `column`,'justifyContent': `center`,},'itemName': {'fontSize': `12px`,'fontFamily': `'Lato-Regular-Bold', sans-serif`,'fontWeight': `bold`,'color': `#000000`,},'itemQuantity': {'fontSize': `12px`,'fontStyle': `italic`,'color': `#000000`,},'title': {'fontFamily': `'Lato-Regular-Bold', sans-serif`,'fontSize': `16px`,'fontWeight': `bold`,'margin': `16px 0px`,'color': `#000000`,},
        
      };
    };
  